import { css } from "@emotion/react";

export const container = css`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  max-width: 90rem;
`;

export const content = css`
  flex: 1;
  justify-content: center;
  margin-block: 3rem;
  display: flex;
`;
